// extracted by mini-css-extract-plugin
export default {"item":"Socials_item__IoQ9H","list":"Socials_list__kcluk","link":"Socials_link__ObxUF"};